

    // $(".quick-view").click(function () {
       $(document).on("click",".quick-view",function() {
            var handlees = $(this).attr("data-handle");
                                  if($(this).parent(".quick-view-button").hasClass("replenish-quick-view"))
                                  {
                                  setTimeout(function() {
                                  $('input[type="radio"][name="subscription"]').prop('checked', true);
                                  }, 500);
                                  }
                                  setTimeout(function() {
                                  if ($('.quick_show_outer').length) {
                                  $('html, body').animate({
                                  scrollTop: $('.quick_show_outer').offset().top
                                  }, 500);
                                  } else {
                                  console.error('Element .quick_show_outer not found.');
                                  }
                                  }, 100); 


      if ($('#quick-view').length == 0){
        $(".quick_show_outer").append('<div id="quick-view"></div>');
      }
                  $("#quick-view").html(content);
                  var product_handle = ''
                  product_handle = $(this).data('handle');
         $('#quick-view').addClass('');
                  $('#quick-view').addClass(product_handle);
// console.log('/products/' + product_handle + '.js');
                                            jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                                            // console.log(product);
                                            var title = product.title;

                                            var type = product.type;

                                            var price = 0;

                                            var original_price = 0;

                                            var desc = product.description;

                                            var images = product.images;

                                            var variants = product.variants;

                                            var options = product.options;

                                            var url = '/products/' + product_handle;

                                            $('.qv-product-title').text(title);

                                            $('.qv-product-type').text(type);

                                            $('.qv-product-description').html(desc);

                                            $('.view-product').attr('href', url);
                                              
                                              $('.qv-add-button').attr('data-handle', product_handle);
                                              
                                            var imageCount = $(images).length;

                                            $(images).each(function (i, image) {

                                            if (i == imageCount - 1) {

                                            var image_embed = '<div><img src="' + image + '"></div>';

                                            // image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                                            $('.qv-product-images').append(image_embed);



                                            $('.qv-product-images').slick({

                                            'dots': true,

                                            'arrows': true,

                                            'respondTo': 'min',

                                            'useTransform': false

                                            }).css('opacity', '1');



                                            } else {

                                            image_embed = '<div><img src="' + image + '"></div>';

                                            // image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');

                                            $('.qv-product-images').append(image_embed);

                                            }
                                           


                                            });


                                            // This is to show variant in radio button
                                            $(options).each(function (i, option) {

                                            var opt = option.name;
                                            var selectClass = '.option.' + opt.toLowerCase();

                                            // Append the container for the options
                                            $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><div class="option-container option-' + i + ' ' + opt.toLowerCase() + '"></div></div>');

                                            // Reference the newly created container
                                            var optionContainer = $('.option-container.option-' + i);

                                            // Iterate over the option values and create radio buttons
                                            $(option.values).each(function (j, value) {
                                            var size_checked = '';
                                            if(j == 0){
                                            size_checked = "checked sdsdsfsfs" ;
                                            }
                                            var radioButtonHtml = '<div class="radio-option">' +
                                            '<input type="radio" id="' + opt.toLowerCase() + '-' + j + '" name="' + opt.toLowerCase() + '" value="' + value + '" '+ size_checked+'>' +
                                            '<label for="' + opt.toLowerCase() + '-' + j + '">' + value + '</label>' +
                                            '</div>';
                                            optionContainer.append(radioButtonHtml);
                                            });
setTimeout(function(){
$("#size-1").click();
$("#size-0").click();
  
  
  }, 300);
                                            });

                                            // append the subscription
                                            // console.log(product.selling_plan_groups);
                                            // $('.qv-product-subs-options').text(jsonSrtingifyproduct.selling_plan_groups);
                                            if($.isEmptyObject(product.selling_plan_groups)) {
                                            $(".qv-product-subs-options").hide();
                                            }else
                                            {
                                            $(".qv-product-subs-options").show();
                                            $(product.selling_plan_groups).each(function (i, option) {
                                            var opt = option.name;
                                            var selectClass = '.option.' + opt.toLowerCase();
                                            $('.subscriptionOptions').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="subs_option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
                                            $(option.selling_plans).each(function (j, value) {
                                            if(j == 0){
                                            $('.subs_option-' + i).append('<option value="' + value.id + '" selected>' + value.name + '</option>');
                                            }
                                            else
                                            {
                                            $('.subs_option-' + i).append('<option value="' + value.id + '">' + value.name + '</option>');
                                            }
                                            });
                                            });
                                            }


                                            $(product.variants).each(function (i, v) {

                                            if (v.inventory_quantity == 0) {

                                            $('.qv-add-button').prop('disabled', true).val('Sold Out');

                                            $('.qv-add-to-cart').hide();

                                            $('.qv-product-price').text('Sold Out').show();

                                            return true

                                            } else {

                                            price = parseFloat(v.price / 100).toFixed(2);

                                            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
                                              // var currency = Shopify.currency.active;
                                               var currency =  $(".quick_show_outer").attr("data-currency_symbol");
                                            $('.qv-product-price').text(currency +' '+ price);

                                            if (original_price > 0) {

                                            $('.qv-product-original-price').text(currency  +' '+ original_price).show();

                                            } else {

                                            $('.qv-product-original-price').hide();

                                            }

                                            $('select.option-0').val(v.option1);

                                            $('select.option-1').val(v.option2);

                                            $('select.option-2').val(v.option3);

                                            return false

                                            }

                                            });

                                            });

  

     


                                              var svg = `
                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-10 h-10" width="40" height="40">
                                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12"></path>
                                              </svg>
                                              `;

                                              $('#quick-view').before('<div class="remove_html">'+svg+'</div>');
                                              $(document).on("click", ".remove_html", function () {
                                              $(this).parent(".quick_show_outer").html('');
                                              });
         
          // $(document).on("change", "#quick-view select", function () {
                                              $(document).on("change", "#quick-view input[type='radio']", function () {

                                              var selectedOptions = '';
                                                // var currency = Shopify.currency.active;
                                                var currency =  $(".quick_show_outer").attr("data-currency_symbol");

                                              selectedOptions = $(this).val();

                                              jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                                               
                                              $(product.variants).each(function (i, v) {

                                              if (v.title == selectedOptions) {

                                              var price = parseFloat(v.price / 100).toFixed(2);

                                              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

                                              var v_qty = v.inventory_quantity;

                                              var v_inv = v.inventory_management;

                                              $('.qv-product-price').text(currency +' '+ price);
                                              // console.log(price,"jkjkkk");
                                              $('.qv-product-original-price').text(currency +' '+ original_price);

                                              if (v_inv == null) {

                                              $('.qv-add-button').prop('disabled', false).val('Add to cart');

                                              } else {

                                              if (v.inventory_quantity < 1) {

                                              $('.qv-add-button').prop('disabled', true).val('Sold Out');

                                              } else {

                                              $('.qv-add-button').prop('disabled', false).val('Add to cart');

                                              }

                                              }

                                              }

                                              });

                                              });

                                              

                                              });

         $(document).on("change", "#quick-view .option-container input[type='radio']", function () {

             // change image on change variatnt
                                          selectedOptions = $('#quick-view input[type="radio"]:checked').val();
                                          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                                          $(product.variants).each(function (i, v) {
                                          if (v.title == selectedOptions) {
                                          // console.log(v.featured_image.src);  
                                                var targetSrc = v.featured_image.src;
                                                var targetSrcnew = targetSrc.replace(/^https?:/, '');
                                                   // Find the index of the slide containing the image
                                                var targetIndex = $('.slick-slider img[src="' + targetSrcnew + '"]').closest('.slick-slide').data('slick-index');
                                                // Navigate to the slide with the target image
                                                if (typeof targetIndex !== 'undefined') {
                                                $('.slick-slider').slick('slickGoTo', targetIndex);
                                                }                                        
                                          }
                                          });
                                          });
});
      

      

      // var product_handle = $('#quick-view').attr('class');

                            // $(document).on("click", ".qv-add-button", function () {

                            //   var qty = $('.qv-quantity').val();

                            //   var selectedOptions = '';

                            //   var var_id = '';

                            //   var cartData = '';
                            //   var currency = Shopify.currency.active;

                            //         // console.log("hanleee", product_handle);
                            //         selectedOptions = $('#quick-view input[type="radio"]:checked').val();
                            //         selectedSubscriptionPlanId = $(".subscriptionOptions select").val();
        
                            //               jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                            //               console.log('/products/' + product_handle + '.js ll');
                            //                 console.log(product.variants);
                            //               $(product.variants).each(function (i, v) {

                            //               if (v.title == selectedOptions) {

                            //               var_id = v.id;
                            //               if ($('input[name="subscription"]:checked').val() === 'subscription') {
                            //               cartData = {
                            //               quantity: qty,
                            //               id: var_id,
                            //               selling_plan: selectedSubscriptionPlanId
                            //               };
                            //                 console.log(v.title +'  -  '+selectedOptions,"equal selected");
                            //               } 
                                            
                            //               else 
                            //               {
                            //               cartData = {
                            //               quantity: qty,
                            //               id: var_id
                            //               };
                            //                 console.log(v.title +'  -  '+selectedOptions,"not equal selected");
                            //               }

                            //               console.log(cartData, "cart data");
                            //               console.log(var_id,"idd");
                            //               processCart();

                            //               }

                            //               });

                            //               });

                            //       function processCart() {

                            //           jQuery.post('/cart/add.js', cartData ,

                            //           null,

                            //           "json"

                            //           ).done(function (response) {
                            //           console.log("cart+Add donne");
                            //           console.log(response);


                            //           $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');

                            //               $.ajax({
                            //               type: 'GET',
                            //               url: '/cart.js',
                            //               dataType: 'json',
                            //               success: function(cartData) {
                            //               console.log(cartData);
                            //               var sell_availeble = '';
                            //               var htmlprod = '';
                            //               var size_html = '';
                            //               var table_start = '<div class="drawer__cart-items-wrapper"></div><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead><tbody role="rowgroup">';
                            //               var table_end = '</tbody></table></div>';
                            //               $.each(cartData.items, function(index, item) {
                            //                   if(item.selling_plan_allocation ){
                            //                   sell_availeble = item.selling_plan_allocation.selling_plan.name;
                            //                   }
                            //                   else{
                            //                   sell_availeble = '';
                            //                   }
                            //                 if(item.variant_title == null){
                            //                    size_html = '';
                            //                 }
                            //                 else
                            //                 {
                            //                   size_html = '<dl><div class="product-option"><dt>Size: </dt><dd>'+item.variant_title+'</dd></div></dl>'; 
                            //                 }
                            //                htmlprod += '<tr id="CartDrawer-Item-'+index+'" class="cart-item" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="'+ item.url+ '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a><img class="cart-item__image" src="'+item.image+'" alt="'+item.product_title+'" loading="lazy" width="150" height="184"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="'+ item.url+ '" class="cart-item__name h4 break">'+item.product_title+'</a><div class="product-option">'+currency + ' '+ parseFloat(item.final_price / 100).toFixed(2) + '</div>'+size_html+'<p class="product-option">'+sell_availeble+'</p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul></td><td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"><div class="loading-overlay hidden"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div><div class="cart-item__price-wrapper"><span class="price price--end">' + currency + ' '+ parseFloat(item.final_price / 100).toFixed(2)+'</span></div></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="cart-item__quantity-wrapper"><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for '+'+item.product_title+'+'</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="'+item.quantity+'" min="0" aria-label="Quantity for Active NAD+ Eye Serum" id="Drawer-quantity-'+index+'" data-index="'+index+'"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for '+'+item.product_title+'+'</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input><cart-remove-button id="CartDrawer-Remove-'+index+'" data-index="'+index+'"><button type="button" class="button button--tertiary" aria-label="Remove Active NAD+ Eye Serum - 5ml w/ Applicator"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>Remove</button></cart-remove-button></div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div></td></tr>';
                                           
                            //               });
                            //                 // console.log(htmlprod);
                            //                 // check if cart is empty
                            //                 var isCartEmpty = $(".drawer__inner-empty").length;
                            //                 var finalHtml = table_start + htmlprod + table_end;
                            //                 if(isCartEmpty  > 0){
                            //                   $('#CartDrawer-CartItems').html(finalHtml);
                            //                   $(".drawer__inner-empty").remove();
                            //                   $("cart-drawer").removeClass("is-empty");
                            //                   $("cart-drawer").addClass("active");
                            //                   $("cart-drawer-items").removeClass("is-empty");
                                              
                                              
                            //                    // console.log(finalHtml);
                            //                       console.log("empty cart append");
                                              
                            //                 }else
                            //                 {
                            //                   console.log("Not empty cart append");
                            //                   $('.cart-items tbody').html(htmlprod);
                            //                   $(".drawer__inner-empty").remove();
                            //                   $("cart-drawer").removeClass("is-empty");
                            //                   $("cart-drawer-items").removeClass("is-empty");
                            //                   $("cart-drawer").addClass("active");                                              
                                              
                            //                   // console.log(htmlprod);
                            //                 }
                            //                 // $('.cart-items tbody').html(htmlprod);

                            //                  $(".cart-drawer__footer .totals__subtotal-value").text('$ '+ parseFloat(cartData.total_price / 100).toFixed(2));
                            //                  $(".drawer__header .items-count").text((cartData.item_count) + 'Items');
                                          
                            //               },
                            //               error: function(xhr, status, error) {
                            //               console.error('Error fetching cart data:', status, error);
                            //               }
                            //               });
                            //              console.log("after_cart_refresh");
                                  
                            //             })

                            //             .fail(function ($xhr) {

                            //               var data = $xhr.responseJSON;

                            //               $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);

                            //             });

                            //           }

                            // });

    




  // console.log(content,"aftershow");
      $("#quick-view").html(content);
      $("#quick-view").html(image_embed);
         
         
     


  

      $('#quick-view').removeClass().empty();

  

    });



  

  $(window).resize(function () {

    // if ($('#quick-view').is(':visible')) {

    //   $('.qv-product-images').slick('setPosition');

    // }

     

  });

$(document).ready(function() {

                              $(document).on("click", ".qv-add-button", function () {

                              var qty = $('.qv-quantity').val();

                              var selectedOptions = '';

                              var var_id = '';

                              var cartData = '';
                                $(".add_btn .loading-overlay__spinner").removeClass("hidden");
                              // var currency = Shopify.currency.active;
                                                var currency =  $(".quick_show_outer").attr("data-currency_symbol");
                                
                                 product_handle  = $(this).attr("data-handle");
                                    // console.log("hanleee", product_handle);
                                    selectedOptions = $('#quick-view input[type="radio"]:checked').val();
                                    selectedSubscriptionPlanId = $(".subscriptionOptions select").val();
        
                                          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
                                          console.log('/products/' + product_handle + '.js ll');
                                            console.log(product.variants);
                                          $(product.variants).each(function (i, v) {

                                          if (v.title == selectedOptions) {

                                          var_id = v.id;
                                          if ($('input[name="subscription"]:checked').val() === 'subscription') {
                                          cartData = {
                                          quantity: qty,
                                          id: var_id,
                                          selling_plan: selectedSubscriptionPlanId
                                          };
                                            console.log(v.title +'  -  '+selectedOptions,"equal selected");
                                          } 
                                            
                                          else 
                                          {
                                          cartData = {
                                          quantity: qty,
                                          id: var_id
                                          };
                                            console.log(v.title +'  -  '+selectedOptions,"not equal selected");
                                          }

                                          console.log(cartData, "cart data");
                                          console.log(var_id,"idd");
                                          processCart();

                                          }

                                          });

                                          });

                                  function processCart() {

                                      jQuery.post('/cart/add.js', cartData ,

                                      null,

                                      "json"

                                      ).done(function (response) {
                                      console.log("cart+Add donne");
                                      console.log(response);
                                      ensureProductsInCart_quickviewjs(40355229073457, 40532562051121);


                                      $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');

                                          $.ajax({
                                          type: 'GET',
                                          url: '/cart.js',
                                          dataType: 'json',
                                          success: function(cartData) {
                                          console.log(cartData);
                                          var sell_availeble = '';
                                          var htmlprod = '';
                                          var size_html = '';
                                          var table_start = '<div class="drawer__cart-items-wrapper"></div><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead><tbody role="rowgroup">';
                                          var table_end = '</tbody></table></div>';
                                          $.each(cartData.items, function(index, item) {
                                            index++;
                                              if(item.selling_plan_allocation ){
                                              sell_availeble = item.selling_plan_allocation.selling_plan.name;
                                              }
                                              else{
                                              sell_availeble = '';
                                              }
                                            if(item.variant_title == null){
                                               size_html = '';
                                            }
                                            else
                                            {
                                              size_html = '<dl><div class="product-option"><dt>Size: </dt><dd>'+item.variant_title+'</dd></div></dl>'; 
                                            }
                                           htmlprod += '<tr id="CartDrawer-Item-'+index+'" class="cart-item" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="'+ item.url+ '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a><img class="cart-item__image" src="'+item.image+'" alt="'+item.product_title+'" loading="lazy" width="150" height="184"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><a href="'+ item.url+ '" class="cart-item__name h4 break">'+item.product_title+'</a><div class="product-option">'+currency + ' '+ parseFloat(item.final_price / 100).toFixed(2) + '</div>'+size_html+'<p class="product-option">'+sell_availeble+'</p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul></td><td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal"><div class="loading-overlay hidden"><div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div><div class="cart-item__price-wrapper"><span class="price price--end">' + currency + ' '+ parseFloat((item.quantity)*(item.final_price / 100)).toFixed(2)+'</span></div></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="cart-item__quantity-wrapper"><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for '+'+item.product_title+'+'</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="'+item.quantity+'" min="0" aria-label="Quantity for Active NAD+ Eye Serum" id="Drawer-quantity-'+index+'" data-index="'+index+'"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for '+'+item.product_title+'+'</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input><cart-remove-button id="CartDrawer-Remove-'+index+'" data-index="'+index+'"><button type="button" class="button button--tertiary" aria-label="Remove Active NAD+ Eye Serum - 5ml w/ Applicator"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>Remove</button></cart-remove-button></div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div></td></tr>';
                                           
                                          });
                                            // console.log(htmlprod);
                                            // check if cart is empty
                                            var isCartEmpty = $(".drawer__inner-empty").length;
                                            var finalHtml = table_start + htmlprod + table_end;
                                            if(isCartEmpty  > 0){
                                              $('#CartDrawer-CartItems').html(finalHtml);
                                              $(".drawer__inner-empty").remove();
                                              $("cart-drawer").removeClass("is-empty");
                                              $("cart-drawer").addClass("active");
                                              $("cart-drawer-items").removeClass("is-empty");
                                              
                                              
                                               // console.log(finalHtml);
                                                  console.log("empty cart append");
                                              
                                            }else
                                            {
                                              console.log("Not empty cart append");
                                              $('.cart-items tbody').html(htmlprod);
                                              $(".drawer__inner-empty").remove();
                                              $("cart-drawer").removeClass("is-empty");
                                              $("cart-drawer-items").removeClass("is-empty");
                                              $("cart-drawer").addClass("active");                                              
                                              
                                              // console.log(htmlprod);
                                            }
                                            // $('.cart-items tbody').html(htmlprod);

                                             $(".cart-drawer__footer .totals__subtotal-value").text(currency +' '+ parseFloat(cartData.total_price / 100).toFixed(2));
                                             $(".drawer__header .items-count").text((cartData.item_count) + ' items');
                                              $('.cart-count-bubble span:first').text(cartData.item_count);
                                             $(".add_btn .loading-overlay__spinner").addClass("hidden");
                                              $('#CartDrawer-Checkout').removeAttr('disabled');
                                              console.log("Innnn count",cartData.item_count);
                                          
                                          },
                                          error: function(xhr, status, error) {
                                          console.error('Error fetching cart data:', status, error);
                                           $(".add_btn .loading-overlay__spinner").addClass("hidden");
                                            
                                          }
                                          });
                                         console.log("after_cart_refresh");
                                  
                                        })

                                        .fail(function ($xhr) {

                                          var data = $xhr.responseJSON;

                                          $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);

                                        });

                                      }

                            });
  
  
    $(document).on("change",'input[name="subscription"]',function() {
                if ($('input[name="subscription"]:checked').val() === 'subscription') {
                    $('.subscriptionOptions').show();
                } else {
                    $('.subscriptionOptions').hide();
                }
            });
  
  $(document).on("click", ".plus", function () {
        var $quantity = $(this).siblings('.qv-quantity');
        var currentValue = parseInt($quantity.val());
        $quantity.val(currentValue + 1);
    });

    
      $(document).on("click", ".minus", function () {
        var $quantity = $(this).siblings('.qv-quantity');
        var currentValue = parseInt($quantity.val());
        if (currentValue > parseInt($quantity.attr('min'))) {
            $quantity.val(currentValue - 1);
        }
    });
});


















// ##################################### AUTO ADD PRDOCT GIF#########################




function ensureProductsInCart_quickviewjs(giftId1, giftId2) {
  $.getJSON('/cart.js', function (cart) {
    const giftIds = [giftId1, giftId2];
    const giftsInCart = cart.items.filter(item => giftIds.includes(item.id));
    const nonGiftItems = cart.items.filter(item => !giftIds.includes(item.id));

    // 🧩 CASE 1: Only gifts in cart → remove by key
    if (nonGiftItems.length === 0 && giftsInCart.length > 0) {
      console.log("❌ Only gifts in cart — removing by key...");

      giftsInCart.forEach(gift => {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: gift.key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            console.log(`🗑️ Removed gift: ${gift.title} (key: ${gift.key})`);
            refreshCartDrawer_quickviewjs();
          },
          error: function (xhr, status, error) {
            console.error('❌ Error removing gift:', gift.title, error);
          }
        });
      });
      return;
    }

    // 🧩 CASE 2: Regular items exist → ensure both gifts are in cart
    const productIdsInCart = cart.items.map(item => item.id);
    const toAdd = [];

    if (nonGiftItems.length > 0) {
      if (!productIdsInCart.includes(giftId1)) {
        toAdd.push({ id: giftId1, quantity: 1 });
      }
      if (!productIdsInCart.includes(giftId2)) {
        toAdd.push({ id: giftId2, quantity: 1 });
      }

      if (toAdd.length === 0) {
        console.log('✅ Both gifts already in cart');
        return;
      }

      console.log("🎁 Adding missing gifts:", toAdd);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: toAdd }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          console.log('✅ Added missing gifts to cart:', toAdd);
          refreshCartDrawer_quickviewjs();
        },
        error: function (xhr, status, error) {
          console.error('❌ Error adding gifts:', status, error);
        }
      });
    }
  });
}



function refreshCartDrawer_quickviewjs() {
  var currency =  $("body").attr("data-bodycurrency_symbol");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (cartData) {
      console.log('🛒 Cart refreshed:', cartData);

      var sell_availeble = '';
      var htmlprod = '';
      var size_html = '';
      var table_start = '<div class="drawer__cart-items-wrapper"></div><table class="cart-items" role="table"><thead role="rowgroup"><tr role="row"><th id="CartDrawer-ColumnProductImage" role="columnheader"><span class="visually-hidden">Product image</span></th><th id="CartDrawer-ColumnProduct" class="caption-with-letter-spacing" scope="col" role="columnheader">Product</th><th id="CartDrawer-ColumnTotal" class="right caption-with-letter-spacing" scope="col" role="columnheader">Total</th><th id="CartDrawer-ColumnQuantity" role="columnheader"><span class="visually-hidden">Quantity</span></th></tr></thead><tbody role="rowgroup">';
      var table_end = '</tbody></table></div>';

      $.each(cartData.items, function (index, item) {
        index++;
        sell_availeble = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : '';
        size_html = item.variant_title ? '<dl><div class="product-option"><dt>Size: </dt><dd>' + item.variant_title + '</dd></div></dl>' : '';

        htmlprod += '<tr id="CartDrawer-Item-' + index + '" class="cart-item" role="row">' +
          '<td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">' +
          '<a href="' + item.url + '" class="cart-item__link" tabindex="-1" aria-hidden="true"></a>' +
          '<img class="cart-item__image" src="' + item.image + '" alt="' + item.product_title + '" loading="lazy" width="150" height="184"></td>' +
          '<td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">' +
          '<a href="' + item.url + '" class="cart-item__name h4 break">' + item.product_title + '</a>' +
          '<div class="product-option">' +currency + ' '+ parseFloat(item.final_price / 100).toFixed(2) + '</div>' +
          size_html + '<p class="product-option">' + sell_availeble + '</p></td>' +
          '<td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">' +
          '<div class="cart-item__price-wrapper"><span class="price price--end">'+currency + ' '+ parseFloat((item.quantity) * (item.final_price / 100)).toFixed(2) + '</span></div></td>' +
          '<td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">' +
          '<div class="cart-item__quantity-wrapper"><quantity-input class="quantity">' +
          '<input class="quantity__input" type="number" name="updates[]" value="' + item.quantity + '" min="0" aria-label="Quantity for ' + item.product_title + '" id="Drawer-quantity-' + index + '" data-index="' + index + '">' +
          '</quantity-input></div></td></tr>';
      });

      var finalHtml = table_start + htmlprod + table_end;
      var isCartEmpty = $(".drawer__inner-empty").length;

      if (isCartEmpty > 0) {
        $('#CartDrawer-CartItems').html(finalHtml);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
        console.log("🆕 Empty cart filled");
      } else {
        console.log("🔄 Updated cart");
        $('.cart-items tbody').html(htmlprod);
        $(".drawer__inner-empty").remove();
        $("cart-drawer").removeClass("is-empty").addClass("active");
        $("cart-drawer-items").removeClass("is-empty");
      }

      $(".cart-drawer__footer .totals__subtotal-value").text(currency + ' ' + parseFloat(cartData.total_price / 100).toFixed(2));
      $(".drawer__header .items-count").text(cartData.item_count + ' items');
      $('.cart-count-bubble span:first').text(cartData.item_count);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
      $('#CartDrawer-Checkout').removeAttr('disabled');
    },
    error: function (xhr, status, error) {
      console.error('Error fetching cart data:', status, error);
      $(".add_btn .loading-overlay__spinner").addClass("hidden");
    }
  });
}
